import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { MerchantOverviewMovementPage } from './merchant-overview-movement';

@NgModule({
  declarations: [
    MerchantOverviewMovementPage,
  ],
  imports: [
    IonicPageModule.forChild(MerchantOverviewMovementPage),
    TranslateModule.forChild()
  ],
})
export class MerchantOverviewMovementPageModule {}



// WEBPACK FOOTER //
// ./src/pages/merchant-overview-movement/merchant-overview-movement.module.ts